import React, { useState } from 'react';
import { Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';

const MaskedCredentialsInput = ({ value, onChange, buildId }) => {
  const [revealed, setRevealed] = useState(false);

  if (buildId && value && !revealed) {
    return (
      <Input
        value="••••••••••••"
        readOnly
        onClick={() => setRevealed(true)}
        className="credentials-masked-input"
      />
    );
  }

  return (
    <TextArea
      rows={4}
      value={value}
      onChange={onChange}
      placeholder="Test Account Credentials And QA Instructions"
      onBlur={() => {
        if (buildId) setRevealed(false);
      }}
    />
  );
};

export default MaskedCredentialsInput;
